import apiConfig from '@constants/apiConfig';

import DigibesDeviceDetailPage from './digibes';
import ListOrderconPage from '.';

export default {
    listOrderconDevicePage: {
        path: '/ordercon',
        title: 'Ordercon Management',
        auth: true,
        component: ListOrderconPage,
        permission: [apiConfig.device.getList.baseURL],
    },
    listDigibesDevicePage: {
        path: '/ordercon/:restaurantId/digibes',
        title: 'Digibes Device Management',
        auth: true,
        component: DigibesDeviceDetailPage,
        permission: [apiConfig.device.getList.baseURL],
    },
};
